export default function IconView({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M30.6936 15.9999C30.6936 15.9999 24.1156 7.69434 15.9991 7.69434C7.88269 7.69434 1.30469 15.9999 1.30469 15.9999C1.30469 15.9999 7.88269 24.3054 15.9991 24.3054C24.1156 24.3054 30.6936 15.9999 30.6936 15.9999Z"
        fill="#E4F1F5"
      />
      <path
        d="M15.9991 7.69434C7.88269 7.69434 1.30469 15.9999 1.30469 15.9999C1.30469 15.9999 1.82347 16.6541 2.74858 17.5958C5.11885 15.1859 10.161 10.8888 15.9991 10.8888C21.8373 10.8888 26.8794 15.1859 29.2497 17.5984C30.1748 16.6567 30.6936 15.9999 30.6936 15.9999C30.6936 15.9999 24.1156 7.69434 15.9991 7.69434Z"
        fill="white"
      />
      <path
        d="M15.9998 21.1256C18.8225 21.1256 21.1109 18.8372 21.1109 16.0144C21.1109 13.1916 18.8225 10.9033 15.9998 10.9033C13.177 10.9033 10.8887 13.1916 10.8887 16.0144C10.8887 18.8372 13.177 21.1256 15.9998 21.1256Z"
        fill="#66E1FF"
      />
      <path
        d="M12.3868 19.6272C11.4459 18.6652 10.9224 17.3709 10.9298 16.0253C10.9372 14.6798 11.4749 13.3913 12.4264 12.4397C13.3778 11.4881 14.6661 10.9501 16.0118 10.9425C17.3574 10.9348 18.6517 11.4581 19.614 12.3989L12.3868 19.6272Z"
        fill="#C2F3FF"
      />
      <path
        d="M30.6936 15.9999C30.6936 15.9999 24.1156 7.69434 15.9991 7.69434C7.88269 7.69434 1.30469 15.9999 1.30469 15.9999C1.30469 15.9999 7.88269 24.3054 15.9991 24.3054C24.1156 24.3054 30.6936 15.9999 30.6936 15.9999Z"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9998 21.1256C18.8225 21.1256 21.1109 18.8372 21.1109 16.0144C21.1109 13.1916 18.8225 10.9033 15.9998 10.9033C13.177 10.9033 10.8887 13.1916 10.8887 16.0144C10.8887 18.8372 13.177 21.1256 15.9998 21.1256Z"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
